__turbopack_context__.v({
  "tooltipArrowBottom": "style-module__KmWj4W__tooltipArrowBottom",
  "tooltipArrowTop": "style-module__KmWj4W__tooltipArrowTop",
  "tooltipBoxBottom": "style-module__KmWj4W__tooltipBoxBottom",
  "tooltipBoxTop": "style-module__KmWj4W__tooltipBoxTop",
});
